export { default } from './post-metadata-layout';
